import { useRef, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function TextEffectLines({ title }) {
  const textRef = useRef();

  useEffect(() => {
    const text = textRef.current;
    text.innerHTML = ""; // 초기화

    // 문자열을 <br> 기준으로 나누고 각 줄에 애니메이션 적용
    const lines = title.split("<br>");
    lines.forEach((line, index) => {
      const lineContainer = document.createElement("div"); // 각 줄 컨테이너
      lineContainer.className = "line";

      line.split("").forEach((letter) => {
        const span = document.createElement("span");
        span.textContent = letter;
        lineContainer.appendChild(span);
      });

      text.appendChild(lineContainer);
      if (index < lines.length - 1)
        text.appendChild(document.createElement("br")); // 줄바꿈 추가
    });

    gsap.fromTo(
      ".typing-text span",
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.1,
        stagger: 0.03,
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: textRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, [title]);

  return (
    <h1
      ref={textRef}
      className="typing-text mt-4 text-4xl tracking-tight text-white max-w-4xl m-auto"
    ></h1>
  );
}
